// frontend/src/components/Manual/ManualNav.tsx

import React from 'react';

interface NavItem {
  key: string;
  icon: string;
  label: string;
}

interface Props {
  active: string;
  onSelect: (key: string) => void;
  availableSections: string[];
}

// ============================================================
// Itens do menu
// ============================================================
const ITEMS: NavItem[] = [
  { key: 'intro',            icon: '📌', label: 'Primeiros Passos'   },
  { key: 'dashboard',        icon: '📊', label: 'Visão Geral'        },
  { key: 'importar-dados',   icon: '📤', label: 'Importar Dados'     },
  { key: 'processamento',    icon: '🔧', label: 'Processamento'      },
  { key: 'meus-dados',       icon: '📋', label: 'Meus Dados'         },
  { key: 'acompanhamento',   icon: '📡', label: 'Acompanhamento'     },
  { key: 'jornada',          icon: '📖', label: 'Jornada dos Dados'  },
  { key: 'analise',          icon: '🔬', label: 'Análise'            },
  { key: 'exploracao',       icon: '📈', label: 'Exploração'         },
  { key: 'preparacao',       icon: '🧹', label: 'Preparação'         },
  { key: 'modelos',          icon: '🤖', label: 'Modelos'            },
  { key: 'comparar-modelos', icon: '📊', label: 'Comparar Modelos'   },
  { key: 'predicoes',        icon: '🎯', label: 'Predições'          },
];

// ============================================================
// Componente
// ============================================================
export const ManualNav: React.FC<Props> = ({ active, onSelect, availableSections }) => {
  const visibleItems = ITEMS.filter(item => availableSections.includes(item.key));

  return (
    <nav className="manual-nav">
      <div className="manual-nav-list">
        {visibleItems.map((item) => {
          const isActive = active === item.key;

          return (
            <button
              key={item.key}
              type="button"
              className={`manual-nav-item ${isActive ? 'active' : ''}`}
              onClick={() => onSelect(item.key)}
            >
              <span className="manual-nav-icon">{item.icon}</span>
              <span className="manual-nav-label">{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};